import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-dots-vertical-icon',
  templateUrl: 'dots-vertical-icon.component.html'
})
export class DotsVerticalIconComponent {
  constructor() {}
}
